import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-737d2be2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-busy"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["aria-posinset", "aria-setsize", "id", "aria-labelledby", "aria-describedby"]
const _hoisted_4 = ["id", "href"]
const _hoisted_5 = ["id", "datetime"]
const _hoisted_6 = ["id", "innerHTML"]
const _hoisted_7 = ["id"]
const _hoisted_8 = {
  key: 1,
  class: "entry loading"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "body" }, " Loading... Please wait. ", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.count)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        role: "feed",
        "aria-label": "TMW news",
        "aria-busy": _ctx.count > 1 && !_ctx.fullyLoaded,
        class: "news"
      }, [
        (!_ctx.entries.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(no news entries)"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry, index) => {
          return (_openBlock(), _createElementBlock("article", {
            tabindex: "0",
            class: "entry",
            "aria-posinset": index + 1,
            "aria-setsize": _ctx.entries.length,
            id: entry.id,
            "aria-labelledby": entry.id + '-title',
            "aria-describedby": `${entry.id}-body ${entry.id}-date ${entry.id}-author`,
            key: entry.id
          }, [
            _createElementVNode("header", null, [
              _createElementVNode("a", {
                tabindex: "-1",
                id: entry.id + '-title',
                href: '#' + entry.id
              }, _toDisplayString(entry.title), 9, _hoisted_4)
            ]),
            _createElementVNode("time", {
              id: entry.id + '-date',
              "aria-label": "publication date",
              datetime: entry.date,
              class: "date"
            }, _toDisplayString(entry.date), 9, _hoisted_5),
            _createElementVNode("section", {
              id: entry.id + '-body',
              class: "body",
              innerHTML: entry.html
            }, null, 8, _hoisted_6),
            _createElementVNode("q", {
              id: entry.id + '-author',
              "aria-label": "author"
            }, _toDisplayString(entry.author), 9, _hoisted_7)
          ], 8, _hoisted_3))
        }), 128)),
        (_ctx.count > 1 && !_ctx.fullyLoaded)
          ? (_openBlock(), _createElementBlock("article", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}